import React from "react";
import _ from "lodash";
import leftPad from "left-pad";
import ReactBootstrapSlider from "react-bootstrap-slider";
import "../../styles/slider-styles.css";
import ActiveIcon from "../vectors/ActiveIcon";
const timeIcon = require("../../styles/time-icon.svg");

interface FilterByTimeProps {
  selectedTime: {
    minuteFrom: number;
    minuteTo: number;
    active: boolean;
  };
  updateFilter: Function;
  photoTimeRange: {
    min: number;
    max: number;
  };
  expanded: boolean;
  collapseFilter: Function;
  isActive: boolean;
  pageConfig: {
    accentColor: string;
  };
  trackFilterEvents: (filterType: string) => void;
}

interface FilterByTimeState {
  minuteFrom: number;
  minuteTo: number;
}

class FilterByTime extends React.Component<
  FilterByTimeProps,
  FilterByTimeState
> {
  fullRange: number[];
  constructor(props: FilterByTimeProps) {
    super(props);
    this.fullRange = [0, 1439];

    this.state = {
      minuteFrom: this.props.selectedTime.minuteFrom || this.fullRange[0],
      minuteTo: this.props.selectedTime.minuteTo || this.fullRange[1]
    };
  }

  componentWillReceiveProps(nextProps: {
    selectedTime: { minuteFrom: any; minuteTo: any };
  }) {
    this.setState({
      minuteFrom: nextProps.selectedTime.minuteFrom,
      minuteTo: nextProps.selectedTime.minuteTo
    });
  }

  selectionChanged = (event: { target: { value: any[] } }) => {
    let selectedRange = [event.target.value[0], event.target.value[1]];

    this.props.updateFilter({
      minuteFrom: selectedRange[0],
      minuteTo: selectedRange[1],
      active: this.isFilterActive(selectedRange)
    });
    this.props.trackFilterEvents("photoTime");
  };

  sliderMoved = (event: { target: { value: any[] } }) => {
    this.setState({
      minuteFrom: event.target.value[0],
      minuteTo: event.target.value[1]
    });
  };

  isFilterActive = (selectedRange: any[]) =>
    // if the entire range is selected,
    // then we do not apply time filter
    // so that images without timestamp
    // dont miss out.
    !_.isEqual(selectedRange, this.fullRange);

  minutesToHHMM = (minutes: number) => {
    //@ts-ignore
    let hour24 = parseInt(minutes / 60);
    let hour12 = hour24 % 12 || 12;
    let min = minutes % 60;
    let mer = hour24 < 12 || hour24 === 24 ? "AM" : "PM";

    return `${leftPad(hour12, 2, "0")}:${leftPad(min, 2, "0")} ${mer}`;
  };

  sliderTooltipFormatter = (value: any[]) => {
    if (_.isArray(value)) {
      return `${this.minutesToHHMM(value[0])} - ${this.minutesToHHMM(
        value[1]
      )}`;
    } else return undefined;
  };

  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-heading" role="tab" id="headingTwo">
          {this.props.isActive && (
            <div className="active-icon">
              <ActiveIcon color={this.props.pageConfig.accentColor} />
            </div>
          )}
          <img src={timeIcon} alt="" className="filter-icon" />
          <h4 className="panel-title">
            <a
              aria-expanded={this.props.expanded}
              className={`${this.props.expanded ? "" : "collapsed"}  ${
                this.props.isActive ? "active" : "inactive"
              }`}
              onClick={e => this.props.collapseFilter(e, "time")}
              role="button"
              data-toggle="collapse"
              data-parent="#filter-accordion"
              href="#collapseTwo"
              aria-controls="collapseTwo"
            >
              Time of Participation
            </a>
          </h4>
        </div>
        <div
          id="collapseTwo"
          className={
            "panel-collapse collapse " + (this.props.expanded ? "in" : "")
          }
          role="tabpanel"
          aria-labelledby="headingTwo"
        >
          <div className="panel-body">
            <div className="dv-rslider">
              <ReactBootstrapSlider
                value={[this.state.minuteFrom, this.state.minuteTo]}
                slideStop={this.selectionChanged}
                change={this.sliderMoved}
                step={1}
                max={this.props.photoTimeRange.max}
                min={this.props.photoTimeRange.min}
                range={true}
                tooltip={"hide"}
                formatter={this.sliderTooltipFormatter}
              />
              <p>{this.minutesToHHMM(this.state.minuteFrom)}</p>
              <p>{this.minutesToHHMM(this.state.minuteTo)}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FilterByTime;
